import { router, useFocusEffect, usePathname } from 'expo-router';
import { useCallback } from 'react';

import useDialogModal from '@fhs-legacy/frontend/src/hooks/use-dialog-modal';
import { RBIEnv, env } from '@fhs-legacy/frontend/src/utils/environment';
import logger from '@fhs-legacy/frontend/src/utils/logger';
import { useMaybeOsActionHandler } from '@fhs-legacy/frontend/src/utils/os-action';

export { ErrorBoundary } from '@fhs/routing/src/components/page-dev-error-boundary';

export default function OsActionPage() {
  const pathname = usePathname();
  const handleMaybeOsAction = useMaybeOsActionHandler();
  const currentEnv = env();

  const [DialogModal, openDialog] = useDialogModal({
    onConfirm: () => {
      logger.info('[os-action test] Dialog confirmed');
      router.replace(router.canGoBack() ? '../' : '/');
    },
    allowDismiss: false,
    modalAppearanceEventMessage: `OS Action: ${pathname}`,
  });

  useFocusEffect(
    useCallback(() => {
      (async () => {
        if (currentEnv !== RBIEnv.PROD && pathname === '/os/review') {
          logger.info(`[os-action test] Mocking OS action for non-prod env: ${pathname}`);
          setTimeout(() => {
            openDialog({
              title: 'Mock Review Action',
              message: 'This is a mock action for the review path in non-production environments.',
            });
          }, 100); // 100ms delay
        } else {
          await handleMaybeOsAction(pathname);
          router.replace(router.canGoBack() ? '../' : '/');
        }
      })();
    }, [currentEnv, handleMaybeOsAction, openDialog, pathname])
  );

  return <DialogModal />;
}
